module.exports = __webpack_public_path__ + "img/GB-ENG.2d5bac56.svg";